import { useEffect } from 'react';

const classes = [
  'nova-route-ajouter-declarations',
  'nova-route-ajouter-maladie',
  'nova-route-liste-declarations',
  'nova-route-declarations',
];

const applyRouteBodyClass = () => {
  const path = decodeURIComponent(window.location.pathname || '').toLowerCase();

  document.body.classList.remove(...classes);

  if (
    path.includes('ajouterdeclarations') ||
    path.includes('ajouter-declarations') ||
    path.includes('ajouter-declaration')
  ) {
    document.body.classList.add('nova-route-ajouter-declarations');
  }

  if (
    path.includes('ajoutermaladie') ||
    path.includes('ajouter-maladie')
  ) {
    document.body.classList.add('nova-route-ajouter-maladie');
  }

  if (
    path.includes('listedeclarations') ||
    path.includes('liste-declarations')
  ) {
    document.body.classList.add('nova-route-liste-declarations');
  }

  if (
    path.includes('déclarations') ||
    path.includes('declarations') ||
    path.includes('cra')
  ) {
    document.body.classList.add('nova-route-declarations');
  }
};

const NovaRouteBodyClass = () => {
  useEffect(() => {
    applyRouteBodyClass();

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function pushStateWithNovaRouteEvent(...args) {
      const result = originalPushState.apply(this, args);
      window.dispatchEvent(new Event('nova-route-change'));
      return result;
    };

    window.history.replaceState = function replaceStateWithNovaRouteEvent(...args) {
      const result = originalReplaceState.apply(this, args);
      window.dispatchEvent(new Event('nova-route-change'));
      return result;
    };

    window.addEventListener('popstate', applyRouteBodyClass);
    window.addEventListener('nova-route-change', applyRouteBodyClass);

    return () => {
      document.body.classList.remove(...classes);

      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;

      window.removeEventListener('popstate', applyRouteBodyClass);
      window.removeEventListener('nova-route-change', applyRouteBodyClass);
    };
  }, []);

  return null;
};

export default NovaRouteBodyClass;
